export default __webpack_public_path__ + "static/media/avatar_170.4f541e5d.png";